export default __webpack_public_path__ + "static/media/SemanticUI.4c6370e4.png";